import React from "react";
import { Paginator } from "primereact/paginator";
import styled from "styled-components";

export interface PaginationProps {
  first: number;
  rows: number;
  total: number;
  onPageChange: (e: any) => void;
}

const MyPaginator = styled(Paginator)`
  .p-paginator .p-paginator-current,
  .p-paginator-prev,
  .p-paginator-next {
    margin: 0;
  }

  .p-paginator-prev,
  .p-paginator-next {
    color: #dd052b;
    border: 1px solid #d9d9d9;
    background-color: white;
    box-shadow: 0px 3px 6px #00000029;
    font-size: 1rem;
    padding: 0.5rem;
    &:hover {
      cursor: pointer;
      color: #dd052b !important;
      background-color: white !important;
    }
  }
  .p-paginator-current {
    border: 1px solid #d9d9d9;
    background-color: white;
    box-shadow: 0px 3px 6px #00000029;
    padding: 1rem;
    margin:0;
    &:hover {
      cursor: default;
    }
  }
`;

const Pagination: React.FC<PaginationProps> = ({
  first,
  rows,
  total,
  onPageChange,
}) => (
  <MyPaginator
    currentPageReportTemplate="{currentPage} de {totalPages}"
    template="PrevPageLink CurrentPageReport NextPageLink"
    first={first}
    rows={rows}
    totalRecords={total}
    onPageChange={(e) =>
      onPageChange({ first: e.first, rows: e.rows, page: e.page })
    }
  ></MyPaginator>
);

export default Pagination;
